import { Link } from "react-router";
import { useEffect, useState } from "react";
import { Select, Card } from "antd";
import { StarFilled } from "@ant-design/icons";
import { my_routes } from "../router/all_routes";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import Avvvatars from "avvvatars-react";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { toast } from "sonner";
import { getAllClass } from "../../api/pedagogicElement";
import {
  Action,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import { getAllEvaluationPeriodByLevel } from "../../api/generalParam";
import {
  getClassAverageByYear,
  getClassAverageByEvaluationPeriod,
} from "../../api/classement";
import { useCurrentClass } from "../../core/common/context/studentClassContext";

const { Option } = Select;

const ClassementByClass = () => {
  const { selectedYear } = useAcademicYear();
  const { selectedClassClassement, setSelectedClassClassement } =
    useCurrentClass();
  const routes = my_routes;
  const [typeClassement, setTypeClassement] = useState("semestre");
  // const [selectedClass, setSelectedClass] = useState<any>();
  const [selectedPeriod, setSelectedPeriod] = useState<any>();
  const [students, setStudents] = useState<any[]>([]);
  //   const[selectedYear,setSelectedYear]=useState<any>();
  const [allClass, setAllClass] = useState<any[]>([]);

  const [allSemester, setAllSemester] = useState<any[]>([]);
  const [includeResit, setIncludeResit] = useState<boolean>(false);

  // 🔹 Classement trié par Rang
  const sorted = [...students].sort((a, b) => a.rank - b.rank);
  // fonction pour récupérer les classes
  const fetchAllClass = async () => {
    try {
      if (!selectedYear?.id) {
        setAllClass([]);
        return;
      }
      const response = await getAllClass(
        selectedYear?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      //   console.log("all class: ", response.data);
      setAllClass(
        response.data
          .slice() // pour éviter de modifier directement la réponse
          .sort((a: any, b: any) => {
            // Tri par Level.label
            const levelCompare = a.Level.label.localeCompare(
              b.Level.label,
              "fr",
              { numeric: true },
            );
            if (levelCompare !== 0) return levelCompare;

            // Si même Level, tri par class label
            return a.label.localeCompare(b.label, "fr", { numeric: true });
          }),
      );
      // if (!selectedClassClassement || selectedClassClassement === undefined) {
      setSelectedClassClassement(
        response.data.length > 0 ? response.data[0] : undefined,
      );
      // }
    } catch (error: any) {
      // console.log("erreur récupération des classes: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produite, Réessayer plus tard",
      );
    }
  };

  useEffect(() => {
    fetchAllClass();
  }, [selectedYear]);

  useEffect(() => {
    if (!selectedClassClassement?.id) return;
  }, [selectedClassClassement]);

  //   fonction de récupération des semestres en fonction de la classe sélectionnée
  const fetchAllSemester = async () => {
    try {
      if (!selectedClassClassement?.Level?.id) {
        setAllSemester([]);
        return;
      }
      const response = await getAllEvaluationPeriodByLevel(
        selectedClassClassement?.Level?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      // console.log("all semester: ", response.data);
      setAllSemester(response.data);
      setSelectedPeriod(
        response.data.length > 0 ? response.data[0] : undefined,
      );
    } catch (error: any) {
      // console.log("erreur récupération des semestres: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  useEffect(() => {
    fetchAllSemester();
  }, [selectedClassClassement]);

  // fonction pour récupérer les moyennes des étudiants d'une classe par semestre
  const fetchAverageClassByEvaluationPeriod = async () => {
    try {
      if (!selectedPeriod) return;
      if (!selectedClassClassement) return;

      const response = await getClassAverageByEvaluationPeriod(
        {
          periodeEvaluationID: selectedPeriod?.id,
          id_class: selectedClassClassement?.id,
          includeResit: includeResit,
        },
        buildPermissionContext(Resource.NOTE, Action.READ),
      );

      console.log("response: ", response?.averagesByClass[0]);
      setStudents(response?.averagesByClass[0]?.students);
    } catch (error: any) {
      setStudents([]);
      console.log("erreur récupération des moyennes: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // fonction pour récupérer les moyennes des étudiants d'une classe par année
  const fetchAverageClassByYear = async () => {
    try {
      if (!selectedYear?.id) return;
      if (!selectedClassClassement) return;

      const response = await getClassAverageByYear(
        {
          id_class: selectedClassClassement?.id,
          includeResit: includeResit,
        },
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      // console.log("response: ", response);
      setStudents(response?.averagesByClass[0]?.students);
    } catch (error: any) {
      setStudents([]);
      // console.log("erreur récupération des moyennes: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  useEffect(() => {
    if (!selectedPeriod) return;
    if (typeClassement === "semestre") {
      fetchAverageClassByEvaluationPeriod();
    }
    if (typeClassement === "annee") {
      fetchAverageClassByYear();
    }
  }, [typeClassement, selectedPeriod, selectedClassClassement, includeResit]);

  useEffect(() => {
    console.log("Students: ", students);
  }, [students]);
  return (
    <div className="page-wrapper">
      <div className="content">
        {/* 🧭 En-tête */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Classement des étudiants</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={routes.allNotes}>Notes</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Classement par classe
                </li>
              </ol>
            </nav>
          </div>
        </div>

        {/* 🏆 Classement */}
        <Card className="p-3">
          {/* 🎛️ Filtres */}
          <div className="d-flex flex-wrap gap-4 mb-4 align-items-end">
            <div className="d-flex flex-column">
              <label className="mb-1 fw-semibold text-muted small">
                Type de classement
              </label>
              <Select
                value={typeClassement}
                style={{
                  width: 250,
                  borderRadius: 8,
                  boxShadow: "0 2px 6px rgba(0,0,0,.08)",
                }}
                onChange={setTypeClassement}
              >
                <Option value="annee">Classe / Année</Option>
                <Option value="semestre">Classe / Semestre</Option>
              </Select>
            </div>

            <div className="d-flex flex-column">
              <label className="mb-1 fw-semibold text-muted small">
                Classe
              </label>
              <Select
                value={(selectedClassClassement as any)?.id || ""}
                style={{
                  width: 250,
                  borderRadius: 8,
                  boxShadow: "0 2px 6px rgba(0,0,0,.08)",
                }}
                onChange={(id) => {
                  const found = allClass.find((cls) => cls.id === id);
                  setSelectedClassClassement(found);
                }}
              >
                {allClass.map((item: any) => (
                  <Option key={item.id} value={item.id}>
                    {`${item?.Level?.abbreviation} - ${item.label}`}
                  </Option>
                ))}
              </Select>
            </div>

            <div className="d-flex flex-column">
              <label className="mb-1 fw-semibold text-muted small">
                {typeClassement === "semestre" ? "Semestre" : ""}
              </label>
              {typeClassement === "semestre" && (
                <Select
                  value={selectedPeriod?.id}
                  style={{
                    width: 250,
                    borderRadius: 8,
                    boxShadow: "0 2px 6px rgba(0,0,0,.08)",
                  }}
                  onChange={(id) => {
                    const found = allSemester.find((s) => s.id === id);
                    setSelectedPeriod(found);
                  }}
                >
                  {allSemester.map((item: any) => (
                    <Option key={item.id} value={item.id}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              )}
            </div>
          </div>
          <div className="d-flex flex-column flex-md-row gap-3">
            {/* Infos classe / période */}
            <div
              className="d-flex flex-column p-3 rounded shadow-sm"
              style={{
                minWidth: 160,
                background: "linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%)",
                border: "1px solid #e8e8e8",
              }}
            >
              <div
                className="mb-2 fw-semibold"
                style={{ color: "#001529", fontSize: 15 }}
              >
                <span style={{ opacity: 0.7 }}>Année scolaire:</span>{" "}
                {selectedYear?.label}
              </div>

              {selectedClassClassement && (
                <>
                  <div
                    className="mb-2 fw-semibold"
                    style={{ color: "#001529", fontSize: 15 }}
                  >
                    <span style={{ opacity: 0.7 }}>Niveau :</span>{" "}
                    {selectedClassClassement?.Level?.label || ""}
                  </div>
                  <div
                    className="mb-2 fw-semibold"
                    style={{ color: "#001529", fontSize: 15 }}
                  >
                    <span style={{ opacity: 0.7 }}>Classe :</span>{" "}
                    {selectedClassClassement?.label || ""}
                  </div>
                </>
              )}

              {typeClassement === "semestre" && (
                <div
                  className="fw-semibold"
                  style={{ color: "#001529", fontSize: 15 }}
                >
                  <span style={{ opacity: 0.7 }}>Semestre :</span>{" "}
                  {selectedPeriod && selectedPeriod?.label}
                </div>
              )}

              {students.length > 0 && (
                <div
                  className="fw-semibold"
                  style={{ color: "#001529", fontSize: 15 }}
                >
                  <span style={{ opacity: 0.7 }}>Nombre d'étudiants :</span>{" "}
                  {students.length}
                </div>
              )}
            </div>

            {/* Classement */}
            <div className="flex-grow-1 w-100">
              <div className="d-flex justify-content-between gap-3">
                <h4 className="mb-4">Classement</h4>
                <div className="form-check form-check-lg form-switch">
                  <label htmlFor="switch-lg" className="form-check-label">
                    Inclure la compensation
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    defaultChecked={includeResit}
                    onChange={(e) => setIncludeResit(e.target.checked)}
                    id="switch-lg"
                  />
                </div>
              </div>

              <div
                className="d-flex flex-column gap-3 overflow-auto"
                style={{ maxHeight: "calc(100vh - 320px)" }}
              >
                {students.length > 0 ? (
                  sorted.map((student, index) => {
                    const isTop3 = index < 3;
                    const borderColor =
                      index === 0
                        ? "2px solid gold"
                        : index === 1
                          ? "2px solid silver"
                          : index === 2
                            ? "2px solid #b87333"
                            : "1px solid #e0e0e0";

                    return (
                      <div
                        key={student.student?.id}
                        className="p-3"
                        style={{
                          display: "grid",
                          gridTemplateRows: "auto auto", // deux lignes : infos principales + semestres
                          rowGap: "0.5rem",
                          backgroundColor: isTop3
                            ? "rgba(0, 123, 255, 0.5)"
                            : "#f9f9f9",
                          color: isTop3 ? "white" : "black",
                          border: borderColor,
                          borderRadius: 10,
                          boxShadow: isTop3
                            ? "0 2px 8px rgba(0,0,0,0.15)"
                            : "none",
                        }}
                      >
                        {/* Ligne principale */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "80px 1fr 100px",
                            alignItems: "center",
                            columnGap: "1rem",
                          }}
                        >
                          {/* Rang + Médaille */}
                          <div style={{ textAlign: "center" }}>
                            {isTop3 ? (
                              <ImageWithBasePath
                                src={`assets/img/top_of_class_${index + 1}.png`}
                                alt="Médaille"
                                width={50}
                                height={50}
                              />
                            ) : (
                              <span
                                className="text-primary"
                                style={{
                                  fontWeight: "bold",
                                  height: 50,
                                  width: 50,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {index + 1}
                              </span>
                            )}
                          </div>

                          {/* Avatar + Infos étudiant */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.75rem",
                              overflow: "hidden",
                            }}
                          >
                            <Link
                              to={`/student-detail/${student.student.id}`}
                              className="avatar avatar-md flex-shrink-0"
                            >
                              <Avvvatars
                                value={`${
                                  student.student?.firstname?.charAt(0) || ""
                                }${student.student?.lastname?.charAt(0) || ""}`}
                                style="character"
                              />
                            </Link>
                            <div style={{ overflow: "hidden" }}>
                              <p
                                className="mb-0 fw-semibold text-truncate"
                                style={{
                                  maxWidth: 250,
                                  color: isTop3 ? "white" : "#000",
                                }}
                              >
                                <Link
                                  to={`/student-detail/${student.student?.id}`}
                                  className={
                                    isTop3 ? "text-white" : "text-dark"
                                  }
                                >
                                  {student.student?.firstname}{" "}
                                  {student.student?.lastname}
                                </Link>
                              </p>
                              <span className="fs-12 text-truncate text-muted d-block">
                                {student.student?.matricule}
                              </span>
                            </div>
                          </div>

                          {/* Moyenne générale */}
                          <div style={{ textAlign: "right" }}>
                            <StarFilled style={{ color: "#faad14" }} />{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {student?.generalAverage?.toFixed(2) ||
                                student?.generalResult?.average?.toFixed(2) ||
                                "_ _"}
                            </span>{" "}
                            / 20
                          </div>
                        </div>

                        {/* Ligne des moyennes par semestre (si typeClassement === "annee") */}
                        {typeClassement === "annee" &&
                          student?.periodAverages?.length > 0 && (
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: `repeat(${student.periodAverages.length}, 1fr)`,
                                gap: "1rem",
                                padding: "0 80px", // aligné avec le contenu de la première ligne
                              }}
                            >
                              {student.periodAverages
                                .slice()
                                .sort((a: any, b: any) =>
                                  a.label.localeCompare(b.label, "fr", {
                                    numeric: true,
                                  }),
                                )
                                .map((periodeAverage: any, idx: number) => (
                                  <div
                                    key={idx}
                                    style={{ textAlign: "center" }}
                                  >
                                    <div style={{ fontSize: 12, opacity: 0.9 }}>
                                      {periodeAverage?.label}
                                    </div>
                                    <div>
                                      <span style={{ fontWeight: "bold" }}>
                                        {periodeAverage?.average?.toFixed(2) ||
                                          "_ _"}
                                      </span>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          )}
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center text-danger">
                    Aucun étudiant trouvé
                  </div>
                )}
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ClassementByClass;
